export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 2_00.6975541f.jpg";